import React from "react";
import Home from "./components/home/Home";
import "./App.css";
import Header from "./components/static/Header";

function App() {
  return (
    <>
      <Header />
      <Home />
    </>
  );
}

export default App;
